import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './i18n/i18n';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'mobx-react';
import HttpRedirect from 'react-https-redirect';
import App from './App';
import RootStore from './stores';

const rootStore = new RootStore();

// async function init() {
//   var siteInfo = {};

//   switch (window.location.hostname) {
//     case 'localhost':
//     case 'dev.upsolution.co.kr':
//       // return { companyId: 'yokohama01', storeCode: '1002', deliveryType: '0', siteType: 'default' };
//       siteInfo = { companyId: 'yokohama01', storeCode: '1003', deliveryType: '1', siteType: 'baydiamond' };
//       // return { companyId: 'yokohama01', storeCode: '1004', deliveryType: '2', siteType: 'delivery' };
//       break;
//     case 'dev.mobileorder.yokohama-stadium.co.jp':
//       siteInfo = { companyId: 'ys1013', storeCode: '1001', deliveryType: '0', siteType: 'default' };
//       break;
//     case 'mobileorder.yokohama-stadium.co.jp':
//       siteInfo = { companyId: 'ys0100', storeCode: '1021', deliveryType: '0', siteType: 'default' };
//       break;
//     case 'dev.baydiamond.mobileorder.yokohama-stadium.co.jp':
//       siteInfo = { companyId: 'ys3000', storeCode: '1001', deliveryType: '1', siteType: 'baydiamond' };
//       break;
//     case 'baydiamond.mobileorder.yokohama-stadium.co.jp':
//       siteInfo = { companyId: 'ys0300', storeCode: '1007', deliveryType: '1', siteType: 'baydiamond' };
//       break;
//     case 'dev.delivery.mobileorder.yokohama-stadium.co.jp':
//       siteInfo = { companyId: 'ys1013', storeCode: '1002', deliveryType: '2', siteType: 'delivery' };
//       break;
//     case 'delivery.mobileorder.yokohama-stadium.co.jp':
//       siteInfo = { companyId: 'ys0100', storeCode: '1019', deliveryType: '2', siteType: 'delivery' };
//       break;
//     default:
//       siteInfo = { companyId: 'ys0100', storeCode: '1021', deliveryType: '0', siteType: 'default' };
//       break;
//   }

//   await rootStore.commonStore.setData(siteInfo.companyId, siteInfo.storeCode);
//   await rootStore.userStore.setUserDataFromLocalStorage();
//   rootStore.userStore.userData.deliveryType = rootStore.commonStore.deliveryType;
//   rootStore.userStore.saveUserData();

ReactDOM.render(
  <Provider {...rootStore}>
    <HttpRedirect disabled={process.env.REACT_APP_NODE_ENV !== 'production'}>
      <App />
    </HttpRedirect>
  </Provider>,
  document.getElementById('root'),
);
// }

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// init();
